import React, { FC, useEffect, useState } from 'react'
import { Col, DatePicker, Row, Select, Spin } from 'antd'
import moment from 'moment'
import { modelApi } from '../../../../../api'
import { RangePickerProps } from 'antd/es/date-picker'
import RBarChart from '../../../../../components/Charts/RBarChart'
import { formatMomentToApiDate } from '../../../../../utils'
import { IBatteryStatesEnriched } from '../../../../../types/battery'
import { RANGE_TYPES } from '../../../../../constants'

type Props = {
  id: string
}

const BatteryStatesBarChart: FC<Props> = ({ id }) => {
  const [isLoading, setLoading] = useState(true)
  const [batteryStates, setBatteryStates] = useState<IBatteryStatesEnriched>([])
  const [rangeType, setRangeType] = useState<string>(RANGE_TYPES.HOUR)
  const [range, setRange] = useState<RangePickerProps['value']>([
    moment('2020-01-01 00:00:00').startOf('month'),
    moment('2020-03-01 00:00:00').endOf('month'),
  ])

  async function fetchData() {
    try {
      setLoading(true)
      const startDate = formatMomentToApiDate(range?.[0] || moment())
      const endDate = formatMomentToApiDate(range?.[1] || moment())
      const { value } = await modelApi.fetchBatteryStates({
        id,
        startDate,
        endDate,
        range: rangeType,
      })

      const enrichedBatteryStates = Object.entries(value || {}).map(([datetime, value]) => ({
        datetime,
        value,
      }))
      console.log(enrichedBatteryStates)

      setBatteryStates(enrichedBatteryStates)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [range, rangeType])

  return (
    <Spin spinning={isLoading}>
      <Row className='mb-8' justify='end' gutter={8}>
        <Col>
          <Select
            value={rangeType}
            options={Object.entries(RANGE_TYPES).map(([key, type]) => ({
              label: key,
              value: type,
            }))}
            onChange={setRangeType}
          />
        </Col>
        <Col>
          <DatePicker.RangePicker value={range} onChange={(r) => setRange(r)} />
        </Col>
      </Row>
      <RBarChart
        data={batteryStates}
        dataKey='datetime'
        yAxis={{ domain: [0, 100] }}
        bars={[
          {
            dataKey: 'value',
            fill: (dataItem) => (dataItem.value > 20 ? 'green' : 'red'),
          },
        ]}
        dateXAxis
      />
    </Spin>
  )
}

export default BatteryStatesBarChart
